import { Routes, Route } from "react-router-dom";


// Admin Layout
import AdminLayout from "../layout/Admin/Admin-Layout";
// Admin Pages
//import Dashboard from "../pages/Admin-Pages/Dashboard";
import DonemIslemleri from "../pages/Admin-Pages/DonemIslemleri";
import KullaniciIslemleri from "../pages/Admin-Pages/KullaniciIslemleri";
import Basvurular from "../pages/Admin-Pages/Basvurular";
import Ayarlar from "../pages/Admin-Pages/Ayarlar";

// Home Layout
import HomeLayout from "../layout/Home/Home-Layout";
// Home Pages
import Homapage from '../pages/Home-Pages/Home';
import BasvuruSorgulama from '../pages/Home-Pages/Basvuru-Sorgulama';
import BasvuruFormu from '../pages/Home-Pages/Basvuru-Formu';
import FormPrint from "../pages/Home-Pages/Form-Print";

// Login Layout
import AuthLayout from "../layout/Auth/Auth-Layout";
// Login Pages
import Login from "../pages/Auth-Pages/Login";


//Error Layout
import ErrorLayout from "../layout/Error/Error-Layout";
//Error Pages
import Error404 from "../pages/Error/Error-404";
import Error501 from "../pages/Error/Error-501";




const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeLayout />}>
        <Route path="" element={<Homapage />} />
        <Route path="basvuru-sorgulama" element={<BasvuruSorgulama />} />
        <Route path="basvuru-formu" element={<BasvuruFormu />} />
        <Route path="form-print/:basvuruNo" element={<FormPrint />} />
      </Route>
      <Route path="/sedmin" element={<AdminLayout />}>
        <Route path="dashboard" element={<Basvurular />} />
        <Route path="donem-islemleri" element={<DonemIslemleri />} />
        <Route path="kullanici-islemleri" element={<KullaniciIslemleri />} />
        <Route path="basvurular" element={<Basvurular />} />
        <Route path="ayarlar" element={<Ayarlar />} />

        <Route path="*" element={<Error404/>} />
      </Route>
      <Route path="/auth" element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
      </Route>
      <Route path="/error" element={<ErrorLayout />}>
        <Route path="404" element={<Error404 />} />
        <Route path="501" element={<Error501 />} />
      </Route>
      <Route path="/*" element={<Error404 />}/>
    </Routes>
  );
};

export default Routers;
